import { useQuery } from '@tanstack/react-query';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { StatCard } from '@/components/dashboard/StatCard';
import { PaymentsTable } from '@/components/dashboard/PaymentsTable';
import { metricsService } from '@/services/metrics';
import { Users, CreditCard, AlertTriangle, DollarSign, Loader2 } from 'lucide-react';
import { formatCurrency } from '@/lib/utils';

export default function Dashboard() {
  const { data: metricsResponse, isLoading } = useQuery({
    queryKey: ['metrics', 'dashboard'],
    queryFn: () => metricsService.getDashboard(),
  });

  const metrics = metricsResponse?.data;

  if (isLoading) {
    return (
      <DashboardLayout title="Dashboard" subtitle="Upcoming Payments Overview">
        <div className="flex items-center justify-center p-12">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <span className="ml-2 text-muted-foreground">Cargando dashboard...</span>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout title="Dashboard" subtitle="Upcoming Payments Overview">
      <div className="space-y-6 animate-fade-in">
        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <StatCard
            title="Active Clients"
            value={metrics?.activeClients ?? 0}
            icon={Users}
            variant="primary"
          />
          <StatCard
            title="Active Subscriptions"
            value={metrics?.activeSubscriptions ?? 0}
            icon={CreditCard}
            variant="success"
          />
          <StatCard
            title="Expiring in 3 Days"
            value={metrics?.expiringIn3Days ?? 0}
            icon={AlertTriangle}
            variant="warning"
          />
          <StatCard
            title="Monthly Revenue"
            value={`$${formatCurrency(metrics?.monthlyRevenue ?? 0)}`}
            icon={DollarSign}
          />
        </div>

        {/* Payments Table */}
        <PaymentsTable />
      </div>
    </DashboardLayout>
  );
}
